<template>
  <div>
    <el-row>
      <el-col>
        <el-menu :default-active="menus[0]" class="el-menu-demo" mode="horizontal"
                 @select="handleStatusSelect">
          <el-menu-item v-for="item in menus" :key="item" :index="item">
            {{ item }}
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
    <el-row class="topBar">
      <el-col :span="2">
        <label>资质类别</label>
      </el-col>
      <el-col :span="6">
        <el-select v-model="requestData.type" placeholder="请选择资质类别" size="mini">
          <el-option
              v-for="item in qualificationTypes"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <label>搜索</label>
      </el-col>
      <el-col :span="6">
        <el-input v-model="requestData.key" size="mini"
                  placeholder="请输入资质名称进行搜索" @change="getQualificationList">
          <el-button slot="append" icon="el-icon-search" @click="getQualificationList"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-row class="qualificationTable">
      <el-col>
        <el-table :data="tableData" :header-cell-style="headerClass" :border="false">
          <el-table-column prop="name" label="资质名称" :border="false"></el-table-column>
          <el-table-column prop="type" label="资质类别"></el-table-column>
          <el-table-column prop="status" label="状态" align="center"></el-table-column>
          <el-table-column label="有效期" align="center">
            <el-table-column prop="startTime" align="right">
              <template slot-scope="scope">{{ scope.row.startTime | dateFormat }}</template>
            </el-table-column>
            <el-table-column width="30px" align="center">-</el-table-column>
            <el-table-column prop="endTime" align="left">
              <template slot-scope="scope">{{ scope.row.endTime | dateFormat }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="file" label="文件" align="center">
            <template slot-scope="scope">
              <div v-for="item in scope.row.file" :key="item.name">
                <a :href="item.url" target="_blank" class="fileLink">{{ item.name }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-if="requestData.status === '待审核'" slot-scope="scope">
              <el-button type="text" @click="handleCheck(scope.row)">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :title="qualificationDialog.mode"
               :visible.sync="qualificationDialog.dialogVisible"
               width="750px"
               :before-close="handleDialogClose"
               @close="initDialog">
      <el-form ref="form"
               :model="qualificationForm"
               label-width="80px"
               style="margin-right: 10px; margin-left: 10px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="name" label="资质名称">
              <el-input v-model="qualificationForm.name" placeholder="请输入资质名称" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="type" label="资质类别">
              <el-select v-model="qualificationForm.type" placeholder="请选择资质类别" disabled>
                <el-option
                    v-for="item in qualificationTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="dateRange" label="有效时间">
              <el-date-picker
                  v-model="qualificationForm.dateRange"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期" disabled>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="file" label="上传文件">
              <div v-for="item in qualificationForm.file" :key="item.url">
                <a class="fileLink" target="_blank" :href="item.url">{{ item.name }}</a>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passPending">通过</el-button>
        <el-button type="danger" @click="checkForm.dialogVisible = true">驳回</el-button>
        <!--        <el-button type="primary" @click="onSubmit('form')">{{ qualificationDialog.buttonInfo }}</el-button>-->
      </span>
      <el-dialog title="驳回理由" append-to-body
                 :visible.sync="checkForm.dialogVisible"
                 @close="checkForm.reason = ''"
      >
        <el-input v-model="checkForm.reason" type="textarea"
        placeholder="必填" maxlength="255" show-word-limit></el-input>
        <span style="color: red" v-if="checkForm.reason.length === 0">未填写驳回理由！</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="rejectPending">提交</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "QualificationHospitalVer",
  filters: {
    dateFormat(val) {
      let date = new Date(val);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      return y + '/' + m + '/' + d;
    }
  },
  data() {
    return {
      GLOBAL,
      //资质类别
      qualificationTypes: [],
      menus: ['已审核', '待审核', '已驳回', '已注销'],
      requestData: {
        status: '已审核',
        type: '',
        key: ''
      },
      tableData: [],
      qualificationDialog: {
        mode: '审核资质',
        dialogVisible: false,
      },
      qualificationForm: {
        name: '',
        type: '',
        dateRange: [],
        file: [],
      },
      checkForm: {
        qualificationId: -1,
        reason: '',
        dialogVisible: false,
      }
    }
  },
  created() {
    this.getQualificationList();
    this.getQualificationTypes();
  },
  methods: {
    handleStatusSelect(key) {
      this.requestData.status = key;
      this.requestData.type = '';
      this.requestData.key = '';
      this.getQualificationList();
    },
    //表头样式
    //eslint-disable-next-line
    headerClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 1) {
        return 'display: none'
      }
      return 'background: #EBEEF5; text-align: center'
    },
    handleDialogClose(done) {
      this.$confirm("操作未保存，是否退出？")
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },
    initDialog() {
      this.qualificationForm = {
        name: '',
        type: '',
        dateRange: [],
        file: [],
      };
    },
    getQualificationList() {
      this.$store.dispatch("Qualification/getQualificationList", this.requestData)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableData = res.data.data;
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //获取资质类别列表
    getQualificationTypes() {
      this.$store.dispatch('Qualification/getQualificationTypes')
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.qualificationTypes = res.data.data;
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    handleCheck(row) {
      this.qualificationDialog.dialogVisible = true;
      this.qualificationForm = {...row};
      this.qualificationForm.dateRange = [new Date(row.startTime), new Date(row.endTime)];
      this.qualificationForm.file = row.file;
      this.checkForm.qualificationId = row.id;
    },
    //  审核通过
    passPending() {
      this.$confirm('确认通过审核吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('Qualification/passPending', {
          qualificationId: this.checkForm.qualificationId,
        })
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getQualificationList();
            })
            .catch((err) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(err);
              }
            })
        this.$message({
          type: 'success',
          message: '审核成功!'
        });
        this.qualificationDialog.dialogVisible = false;
      })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '操作取消'
            });
          })
    },
  //  驳回资质
    rejectPending(){
      if(this.checkForm.reason.length !== 0){
        this.$store.dispatch('Qualification/rejectPending', {
          qualificationId: this.checkForm.qualificationId,
          reason: this.checkForm.reason,
        })
        .then((res) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(res);
          }
          this.getQualificationList();
        })
        .catch((err) => {
          if(!this.$store.state.visitorMode && GLOBAL.debugMode){
            console.log(err);
          }
          this.$message({
            type: 'info',
            message: '已取消驳回'
          });
        })
        this.checkForm.dialogVisible = false;
        this.qualificationDialog.dialogVisible = false;
        this.$message({
          type: 'success',
          message: '驳回成功!'
        });
      }
    },
  },
  watch: {
    requestData: {
      deep: true,
      handler: function (){
        this.getQualificationList();
      }
    }
  }
}
</script>

<style scoped>
.topBar {
  display: flex;
  align-items: baseline;
  padding: 10px;
}

.qualificationTable {
  padding: 10px;
}

.fileLink {
  color: #409eff;
  text-decoration: none;
}

.fileLink:hover {
  color: rgb(102, 177, 255);
}

/deep/ .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}
</style>
